import * as React from 'react';
import { observer } from 'mobx-react';

import { Icon, ToolTipItem, ToolTipItemMode } from '@app/Components';
import Comments from './Comments';
import { applyDecorators } from "@app/Helpers/Decorator";

type OperationTextProps = {
    operationId: string;
    text: string | null;
    mode?: ToolTipItemMode;
};

@observer
export default class OperationText extends React.Component<OperationTextProps> {

    constructor (props: OperationTextProps) {
        super(props);
        applyDecorators(this);
    }

    render () {
        const { text, operationId, mode } = this.props;
        if (!text)
            return '';

        let separator = text.includes('CommentIds defined:')
            ? 'CommentIds defined:'
            : 'CommentsIds to delete:';

        let textParts = text.split(separator);
        if (textParts.length === 1)
            return text;

        const comments = textParts[textParts.length - 1];
        textParts = textParts.splice(0, textParts.length - 1);

        const ids = comments.match(/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/g)?.map(x => x) || [];
        const targetId = 'comment_target_id_' + operationId;

        return (
            <>
                {textParts.join(' ')}
                {ids?.length && <>
                    <Icon id={targetId} name="comment" className='toolip-comments-button' noSolid />
                    <ToolTipItem text={<Comments ids={ids} />} className="tooltip-comments" targetId={targetId} placement="bottom" mode={mode ?? ToolTipItemMode.MouseClick} />
                </>
                }
            </>
        );
    }
}